const API_BASE_URL: string = (import.meta.env.VITE_API_URL || "").replace(/\/$/, "");

async function req(method: string, path: string, body?: Record<string, unknown>) {
  const headers: Record<string, string> = {};
  if (body) headers["Content-Type"] = "application/json";
  try {
    console.log("[endUser] request", { method, path });
  } catch {}
  const resp = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: Object.keys(headers).length ? headers : undefined,
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    console.log("[endUser] response", { path, status: resp.status, ok: resp.ok });
  } catch {}
  const text = await resp.text();
  let data: any;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = { raw: text };
  }
  if (!resp.ok) {
    const msg = data?.error || data?.message || text || `Request failed (${resp.status})`;
    const error: any = new Error(msg);
    error.status = resp.status;
    throw error;
  }
  return data;
}

export type MeResponse = {
  email?: string;
  hasJgsMapping?: boolean;
  [key: string]: unknown;
};

export async function getMe(): Promise<MeResponse> {
  const data: any = await req("GET", "/users/me");
  const has =
    typeof data?.hasJgsMapping !== "undefined"
      ? !!data.hasJgsMapping
      : typeof data?.has_jgs_mapping !== "undefined"
        ? !!data.has_jgs_mapping
        : undefined;
  try {
    const safe: any = { ...data, hasJgsMapping: has };
    if ("user_token" in safe) safe.user_token = "[REDACTED]";
    console.log("[endUser] /users/me parsed", {
      hasJgsMapping: safe.hasJgsMapping,
      email: safe.email,
      user_id: safe.user_id || safe.id,
    });
  } catch {}
  return { ...data, hasJgsMapping: has };
}

export async function searchJgsStudents(
  name: string,
  state?: string,
  limit: number = 10,
  gender?: string
) {
  const qs = new URLSearchParams();
  if (name) qs.set("name", name);
  if (state) qs.set("state", state);
  if (limit) qs.set("limit", String(limit));
  if (gender === "male" || gender === "female") qs.set("gender", gender);
  // Use user self-service endpoint (requires authentication via cookie). This wraps server-side searchJgs()
  const data = await req("GET", `/users/jgs/search?${qs.toString()}`);
  if (Array.isArray(data)) return data;
  return Array.isArray((data as any)?.students) ? (data as any).students : [];
}

export async function linkMyJgsProfile(jgsProfile: string, jgsStudentId?: string) {
  // User self-service link endpoint
  return req("POST", "/users/jgs/link", { jgsProfile, jgsStudentId });
}

// Coach-specific endpoints
export async function getCoachLinkedProfiles() {
  return req("GET", "/users/coach/linked-profiles");
}

export async function coachLinkProfile(studentId?: string, jgsProfile?: string) {
  const body: Record<string, unknown> = {};
  if (studentId) body.studentId = studentId;
  if (jgsProfile) body.jgsProfile = jgsProfile;
  return req("POST", "/users/coach/link-profile", body);
}

export async function coachUnlinkProfile(jgsProfileId: string) {
  return req("DELETE", "/users/coach/unlink-profile", { jgsProfileId });
}
